module.exports = __webpack_public_path__ + "static/banner-mobile-6af525e07e922622084af99d0046367f.png";